/** @format */

import {Close} from '@mui/icons-material';
import {IconButton, Typography} from '@mui/material';

import {YalperPlatform} from 'graphql/generated/types';

import {sensorName} from 'helpers/sensor_names';

import {SensorAdSystemIcons} from './SensorAdSystemIcons';
import {StyledBox, classes} from './styles';

interface SensorItemProps {
  id: string;
  platforms: ReadonlyArray<YalperPlatform>;
  onRemove: (id: string) => void;
}

export const SensorItem = ({id, platforms, onRemove}: SensorItemProps) => {
  const label = sensorName(id);
  if (!label) return null;

  const handleRemove = () => onRemove(id);

  return (
    <StyledBox className={classes.sensorListItem}>
      <SensorAdSystemIcons platforms={platforms} />
      <Typography className={classes.sensorListItemLabel}>{label}</Typography>
      <IconButton onClick={handleRemove}>
        <Close className={classes.sensorListItemIcon} />
      </IconButton>
    </StyledBox>
  );
};
